import { useController } from "react-hook-form";

import { CheckboxGroup } from "src/designsystem/Checkbox/CheckboxGroup";
import { FormCheckboxGroupProps } from "./Form.types";
import FormField, { useFormField } from "./FormField/FormField";

export function FormCheckboxGroup(props: FormCheckboxGroupProps) {
  const { formFieldProps, childProps } = useFormField(props);
  const { field } = useController({ name: childProps.name });

  return (
    <FormField {...formFieldProps}>
      <CheckboxGroup {...childProps} {...field} />
    </FormField>
  );
}
